$shm_knowledge_manual $shm_hitalama_textbook
	kind \instructions
	api_url \
	api_headers *
	pages <= manual_pages /$mol_view
	Text_page $mol_page
		title <= text_title
		title_content /
			<= Document_title $mol_view
				sub / <= text_title
			<= Edit_toggle $mol_check_icon
				hint \Редактировать документ
				enabled <= edit_enabled false
				checked? <=> editing? false
				Icon <= Edit_icon $mol_icon_pencil
		body /
			<= Text
	Editor* $shm_knowledge_manual_editor
		api_url <= api_url
		api_headers <= api_headers
		kind <= kind
		title <= editor_title* \
		saved? <=> document_saved*? null
		close? <=> editor_close? null
		baseline? <=> editor_baseline*? null
		draft? <=> editor_draft*? \
	text_param <= heading_param \
	Toc_link* $mol_link
		arg <= toc_arg* *
		uri_toggle <= toc_uri* \
		sub <= toc_link_content* /$mol_view_content
	Project_icon* $mol_icon_apps
	Common_icon $mol_icon_folder
